export const questions: Array<[string, string]> = [
  [
    'Who is it for?',
    'Chemistry and physical science teachers in middle school, high school, introductory college and homeschool who want clear, visual material ready to use in class.',
  ],
  ['Content depth?', 'From the particle model and atomic structure to organic chemistry and practical lab skills.'],
  [
    'International?',
    "Yes. Based on internationally used chemistry concepts and terminology; always follow your school's safety rules and local guidelines.",
  ],
  ['Format?', 'Professional PDF files with instant access.'],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  ['Not satisfied?', '7-day refund. 100% money back.'],
];
